import { render, staticRenderFns } from "./RailBottom.vue?vue&type=template&id=2515a9c7&scoped=true&"
import script from "./RailBottom.vue?vue&type=script&lang=js&"
export * from "./RailBottom.vue?vue&type=script&lang=js&"
import style0 from "./railBottom.scss?vue&type=style&index=0&id=2515a9c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515a9c7",
  null
  
)

export default component.exports